import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kayako = defineConnector({
  identifier: "kayako",
  name: "Kayako",
  tagLine: "Help desk and customer support",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://.*\\.kayako\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a Kayako access token",
      items: [
        {
          kind: "markdown",
          content:
            "Use Kayako OAuth 2.0 to create an access token for the instance you want to connect. Kayako expects that token in a Bearer authorization header.",
        },
      ],
    },
    {
      title: "Enter your Kayako connection details",
      items: [
        {
          kind: "input",
          label: "Kayako domain",
          placeholder: "yourteam.kayako.com",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText: "The Kayako domain you want this connection to call.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://${domain}/api/v1/users.json`,
      expectedStatus: [200, 403],
    }),
  },
  publicEnvVars: ({ domain }) => ({
    KAYAKO_URL: domain ? `https://${domain}` : "",
  }),
});
